import {Moment} from 'moment'

export const sameMomentDate = (a: Moment | null, b: Moment | null) =>
  a === b ||
  (a !== null &&
    b !== null &&
    a.date() === b.date() &&
    a.month() === b.month() &&
    a.year() === b.year())
